import { Component, OnInit, ViewChild } from '@angular/core';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { first, shareReplay } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { MessageService } from 'primeng/api';
import { UIChart } from 'primeng/chart';
import { BaseService } from 'src/app/services/common/base.service';
import { Router } from '@angular/router';
import { ReportsService } from 'src/app/services/reports.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
    selector: 'app-mi-area-covered',
    templateUrl: './mi-area-covered.component.html',
    styleUrls: ['./mi-area-covered.component.scss']
})
export class MiAreaCoveredComponent implements OnInit {
    @ViewChild("pieChart") pieChartRef: UIChart;
    @ViewChild("lineChart") lineChartRef: UIChart;
    data: any;
    multiAxisData: any;
    chartOptions: any;
    lineChartList: any[];
    public userID: any;
    pieCHartList: any[];
    public selectedYear: any;
    subjectSub: any;
    public subscriptions: any = [];

    constructor(
        private deptDashBoardService: DepartmentDashboardService,
        private activityRecordService: ActivityRecordService,
        private messageService: MessageService,
        private service: BaseService,
        private router: Router,
        private reportsService: ReportsService,
        private cryptoJsService: CryptoJsService
    ) { }

    ngOnInit() {
        let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
        let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
        this.userID = JSON.parse(payload)?.sub;
        this.data = {
            labels: [],
            datasets: [
                {
                    data: [],
                    backgroundColor: [],
                }
            ]
        };
        this.multiAxisData = {
            labels: [],
            datasets: [{
                label: 'MI Area',
                fill: false,
                borderColor: '#42A5F5',
                data: []
            }, {
                label: 'No Of Applications',
                fill: false,
                borderColor: '#00bb7e',
                data: []
            }]
        };
        this.lineChart();
        this.pieChart();

        this.subjectSub = this.service
        .getSelectedYear()
        .pipe(shareReplay())
        .subscribe((res) => {
            let router = this.router.url;
            // this.routePath=router.split('/')
            this.subscriptions.forEach((sub) => sub.unsubscribe());
            this.selectedYear = res;

            // this.getChartData(this.selectedYear);
        });
    }

    getChartData(selectedYear: any) {
        // this.loading = true;
    
        let reqBody = {
            "financialYear": this.selectedYear,
            "district": '',
            "block": '',
            "constituency": '',
            "village": '',
            "cropid": 0,
            "caste": '',
            "isABY": ''
        }

        let sub = this.reportsService
          .getConsolidatedAggReport(reqBody)
          .pipe(first())
          .subscribe({
            next: (data) => {
            //   this.activityRecordService.activityRecord(
            //     this.userID,
            //     'MI Consolidated  Chart Data',
            //     '',
            //     new Date(),
            //     'Success'
            //   );
              
              if (data?.length > 0) {
                if (!window.sessionStorage.getItem("AggReport1Data")) {
                  window.sessionStorage.setItem("AggReport1Data", JSON.stringify(data));
                }
                // this.summaryData = data[0];
                // this.graphData();
              } else {
                // this.summaryData = [];
              }
            },
            error: (err) => {
            //   this.activityRecordService.activityRecord(
            //     this.userID,
            //     'MI Consolidated Chart Data',
            //     '',
            //     new Date(),
            //     err
            //   );
    
            //   this.messageService.add({
            //     severity: 'error',
            //     summary: 'Error Message',
            //     detail: err,
            //   });
            },
          });    

          this.subscriptions.push(sub);
    }

    lineChart() {
        this.deptDashBoardService.GetLineChartList().pipe(first()).subscribe({
            next: (data) => {
                this.lineChartList = data
                let Agriculturelabels = [];
                let AgriculturemiAreaData = [];
                let AgricultureapplocationDataData = [];
                let Horticulturelabels = [];
                let HorticulturemiAreaData = [];
                let HorticultureapplocationDataData = [];
                let MICADAlabels = [];
                let MICADAmiAreaData = [];
                let MICADAapplocationDataData = [];
                for (let index = 0; index < this.lineChartList.length; index++) {
                    if (this.lineChartList[index].Department == "Agriculture") {
                        AgricultureapplocationDataData.push(this.lineChartList[index].NoOfApplications)
                        AgriculturemiAreaData.push(this.lineChartList[index].Area)
                        Agriculturelabels.push(this.lineChartList[index].FinYear)
                    } else if (this.lineChartList[index].Department == "Horticulture") {
                        HorticultureapplocationDataData.push(this.lineChartList[index].NoOfApplications)
                        HorticulturemiAreaData.push(this.lineChartList[index].Area)
                        Horticulturelabels.push(this.lineChartList[index].FinYear)
                    } else {
                        MICADAapplocationDataData.push(this.lineChartList[index].NoOfApplications)
                        MICADAmiAreaData.push(this.lineChartList[index].Area)
                        MICADAlabels.push(this.lineChartList[index].FinYear)
                    }
                }
                this.multiAxisData.labels = [...Horticulturelabels, ...Agriculturelabels, ...MICADAlabels];
                this.multiAxisData.datasets[0].data = [...HorticulturemiAreaData, ...AgriculturemiAreaData, ...MICADAmiAreaData];
                this.multiAxisData.datasets[1].data = [...HorticultureapplocationDataData, ...AgricultureapplocationDataData, ...MICADAapplocationDataData];
                this.lineChartRef.reinit();
            },
            error: (err) => {
                this.activityRecordService.activityRecord(this.userID, 'Line Chart', '', new Date(), err);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error Message',
                    detail: 'Data error! Line chart not loaded.',
                });
            },
        });
    }
    pieChart() {
        this.deptDashBoardService.GetPieChartList().pipe(first()).subscribe({
            next: (res) => {
                this.pieCHartList = res
                let labels = [];
                let areaData = [];
                let backgroundColors = [];
                for (let index = 0; index < this.pieCHartList.length; index++) {
                    labels.push(this.pieCHartList[index].FinYear)
                    areaData.push(this.pieCHartList[index].Area)
                    const randomColor = "#" + ((1 << 24) * Math.random() | 0).toString(16);
                    backgroundColors.push(randomColor)
                }
                this.data.labels = labels;
                this.data.datasets[0].data = areaData;
                this.data.datasets[0].backgroundColor = backgroundColors;
                this.pieChartRef.reinit();
            },
            error: (err) => {
                this.activityRecordService.activityRecord(this.userID, 'Pie chart', '', new Date(), err);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error Message',
                    detail: 'Data error! Pie chart not loaded.',
                });
            },
        });
    }
    getLightTheme() {
        return {
            plugins: {
                legend: {
                    labels: {
                        color: '#495057'
                    }
                }
            }
        }
    }

    getDarkTheme() {
        return {
            plugins: {
                legend: {
                    labels: {
                        color: '#ebedef'
                    }
                }
            }
        }
    }
}
